export default {
  category_list: [],
};
